document.addEventListener('alpine:init', function () {
    Alpine.data('quicklinkSpy', function () {
        var attr = 'data-quicklink-spy-id';
        var selector = "[".concat(attr, "]");
        return {
            mobileOpen: false,
            travelling: false,
            current: null,
            links: [],
            init: function () {
                var _this = this;
                return function () {
                    var links = Array.from(document.querySelectorAll(selector));
                    if (!links.length)
                        return;
                    document.body.classList.add('has-quicklink-spy');
                    _this.links = links.map(function (link) { return ({
                        el: link,
                        title: link.getAttribute(attr),
                    }); });
                    // Set the 'current' link to the first in the list on page load.
                    _this.current = _this.links[0];
                    _this.initScrollSpy();
                };
            },
            initScrollSpy: function () {
                var _this = this;
                this.links.forEach(function (link) {
                    window.gsap.to(link.el, {
                        scrollTrigger: {
                            start: 'top 50%',
                            trigger: link.el,
                            once: false,
                            onEnter: function () {
                                if (!_this.travelling) {
                                    _this.current = link;
                                }
                            },
                            onEnterBack: function () {
                                if (!_this.travelling) {
                                    _this.current = link;
                                }
                            },
                        },
                    });
                });
            },
            scrollTo: function (link) {
                var _this = this;
                var offset = this.$store.app.lg ? 150 : 100;
                this.$store.app.scrollTo(link.el, offset);
                this.current = link;
                this.mobileOpen = false;
                this.travelling = true;
                // The scrollTo timeout is 1.5s, set a var
                setTimeout(function () {
                    _this.travelling = false;
                }, 1500);
            },
        };
    });
});
